<template>
    <div class="hg-input hg-image-input">
        <span class="img-wrapper">
            <a  href="javascript:void 0;" 
                @click="reset()" v-if="image && enableReset" 
                class="remove" 
                :title="$hisport.i18n('REMOVE')">
                <font-awesome-icon :icon="['fa','trash']" size="2x"/>
            </a>
            <img    :src="$hisport.absolute(image)" v-if="!!image" 
                    :class="{'drop-shadow': (typeof image == 'string') && image.indexOf('.png')>=0 }"
                    v-img-fallback="fallbackImage"/>
        </span>
        <div v-if="configuration && configuration.validate">
            <small class="muted">
                <strong v-i18n="'MAX_IMAGE_SIZE'" />&nbsp;
                {{configuration.validate.max_width + "x" + configuration.validate.max_height}}
            </small>
        </div>
        <b-form-file    :id="'grp-' + field" accept="image/png, image/jpg, image/jpeg"
                        ref="file-input" 
                        @input="onImage($event)"
                        :state="Boolean(image)"
                        :plain="false"
                        :placeholder="$hisport.i18n('BROWSE')"
        ></b-form-file>
    </div>
</template>
<script>
export default {
    props: {
        field: {type: String, default: "logo"},
        image: {type: String, default: ""},
        fallbackImage: {type: String, default: " "},
        configuration: {type: Object, default: null},
        enableReset:   {type: Boolean, default: true}
    },
    methods:{
        reset(){
            this.$emit('change', "");
            var el = this.$refs['file-input'];
            if(Array.isArray(el)) el = el[0];
            if(el && typeof el.reset == "function") el.reset();
        },
        onImage(/*event*/){
            var self = this;
            var reader = new FileReader();
            reader.onload = function (e) {
                if( self.configuration && 
                    self.configuration.validate){ 
                    var errors = [];
                    var img = new Image();
                        img.onload = function(){
                            if(    
                                (self.configuration.validate.max_width && img.naturalWidth > self.configuration.validate.max_width) ||
                                (self.configuration.validate.max_height && img.naturalHeight > self.configuration.validate.max_height)
                            )
                            errors.push("ERROR_SIZE");

                            if(errors.length>0){
                                return setTimeout(function(){
                                    self.$emit('error', errors);
                                    alert([
                                        "Invalid image size!",
                                        "Max supported size is " + self.configuration.validate.max_width + "x" + self.configuration.validate.max_height,
                                        "while actual image is " + img.naturalWidth + "x" + img.naturalHeight
                                    ].join("\r\n"))
                                }, 1000)
                            }
                            self.$emit('change', e.target.result);
                        }
                        img.src = e.target.result;
                }else{
                    self.$emit('change', e.target.result);
                }
            };
            var el = this.$refs['file-input'];
            if(!el) return alert("ERROR");
            if(Array.isArray(el)) el = el[0];
            reader.readAsDataURL(el.files[0]);
        },
    }
}
</script>